module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Ksenia Bure was born in Latvia, when it was still part of the Soviet Union and lived in Latvia until the age of 13, before attending Clifton College boarding school, in the UK. Without speaking English at first, transition to UK was an experience and it was not the last time Ksenia had to make cultural adjustments. As part of her Bachelor degree, German with Management studies, in University College London, Ksenia lived a year abroad in Germany, learning German and writing a dissertation on Jewish Survivors living in Berlin. Upon graduating, Ksenia joined Bloomberg LP and has worked in both London Headquarters and relocated to New York, covering different territories. Ksenia has worked at Bloomberg for 14 years, currently running its EMEA Data and Technology Sales business. Ksenia is married and has a daughter residing in London.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0